export const APP_NAME = "Consulta Facil";

export const AppRouteUrls = {
  Root: "/",
  Login: "/auth/login",
  SignUp: "/signup",
  ChangePassword: "/auth/change-password",
  ForgotPassword: "/auth/forgot-password",
  ResetPassword: "/auth/reset-password",
  Profile: "/profile",
  ProfilePassword: "/profile/password",
  Patients: "/patients",
  Onboarding: "/onboarding",
  System: "/system",
} as const;


export const QUERY_KEYS = {
  getAppointmentsForPatient: (patientId: number) => ["getAppointmentsForPatientApi", patientId],
} as const;
